module.exports = __webpack_public_path__ + "static/media/itai.afc0bc8d.png";